import { getStoreId } from "$/hooks/use-store-information"
import bikeForSaleQueries from "$/lib/queries/bike-for-sale-queries"
import storageLocationQueries from "$/lib/queries/storage-location-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/(app)/_auth/bikes-for-sale/$bikeId/listing",
)({
  loader: async ({ context: { queryClient }, params: { bikeId } }) => {
    const storeId = await getStoreId()
    queryClient.prefetchQuery(bikeForSaleQueries.detail(bikeId))
    if (storeId) {
      queryClient.prefetchQuery(storageLocationQueries.list(storeId))
    }
    return { crumb: "alfred.pages.bikesForSale.crumbs.listing" }
  },
})
